module.exports = __webpack_public_path__ + "static/media/kakaotalk.1bdc75c3.svg";